import { prisma, type Prisma, ResourceType, ActionType } from "client";

// GET
export const getContactById = async (userId: string, id: string) => {
  try {
    const contact = await prisma.profile.findFirst({
      where: {
        id: id,
      },
    });

    return contact;
  } catch (e: any) {
    return e;
  }
};

export const getContactGroupIdById = async (
  userId: string,
  contactGroupId: string,
  page: number = 1,
  pageSize: number = 10,
  invitationId?: string,
  search?: string
) => {
  try {
    const skip = (page - 1) * pageSize;
    const take = pageSize;

    let whereClause: Prisma.ProfileWhereInput = {
      contactBookGroupId: contactGroupId,
    };

    if (search) {
      whereClause = {
        AND: [
          whereClause,
          {
            OR: [
              { name: { contains: search, mode: "insensitive" } },
              { email: { contains: search, mode: "insensitive" } },
              { phoneNumber: { contains: search, mode: "insensitive" } },
            ],
          },
        ],
      };
    }

    const [contacts, totalContacts] = await Promise.all([
      prisma.profile.findMany({
        where: whereClause,
        orderBy: {
          id: "desc",
        },
        ...(invitationId
          ? {
              include: {
                invitationAttendees: {
                  where: { invitationId },
                },
                contactBookGroup: {
                  include: {
                    fields: {
                      include: {
                        formTemplate: true,
                      },
                    },
                    invitationAttendeeCategories: {
                      where: {
                        invitationId,
                        contactBookGroupId: contactGroupId,
                      },
                      include: {
                        invitationAttendees: true,
                        contactBookGroup: {
                          include: {
                            contacts: true,
                            _count: {
                              select: {
                                contacts: true,
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            }
          : {}),
        skip: skip,
        take: take,
      }),
      prisma.profile.count({
        where: whereClause,
      }),
    ]);

    const hasNextPage = skip + take < totalContacts;

    return {
      contacts,
      hasNextPage,
      totalContacts,
      totalPages: Math.ceil(totalContacts / pageSize),
    };
  } catch (e: any) {
    return e;
  }
};

export const updateContactBook = async (
  userId: string,
  id: string,
  updatedData: Prisma.ProfileUpdateInput
) => {
  try {
    const contactBook = await prisma.profile.update({
      where: {
        id,
      },
      data: {
        ...updatedData,
      },
    });

    return contactBook;
  } catch (e: any) {
    return e;
  }
};
export const deleteContactBook = async (userId: string, id: string) => {
  try {
  
    const contactBook = await prisma.profile.delete({
      where: {
        id,
      },
    });

    return contactBook;
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
